import styles from "./ChannelPinnedArticle.module.scss";
import { ChannelPinnedArticleFragment } from "types/api";
import Image from "components/Image";
import LandingMetadata from "./LandingMetadata";
import gql from "graphql-tag";

const ChannelPinnedArticle = ({
  title,
  dek,
  url,
  datePublished,
  riverImage,
  authors,
  ...props
}: ChannelPinnedArticleFragment) => {
  return (
    <section>
      <article className={styles.promoItem}>
        <a
          href={url}
          className={styles.titleLink}
          data-action="click link - featured - title"
        >
          {riverImage && (
            <figure className={styles.figure}>
              <Image
                src={riverImage.url}
                srcSet={riverImage.srcSet || undefined}
                width={riverImage.width}
                height={riverImage.height}
                alt={riverImage.altText || ""}
                lazy={false}
                className={styles.image}
                preload
              />
              <figcaption className={styles.imageCredit}>
                {riverImage.attributionText}
              </figcaption>
            </figure>
          )}
          <h2 className={styles.title}>
            <span dangerouslySetInnerHTML={{ __html: title }} />
          </h2>
        </a>
        {dek && (
          <p className={styles.dek} dangerouslySetInnerHTML={{ __html: dek }} />
        )}
        {authors && datePublished && (
          <div className={styles.metadata}>
            <LandingMetadata
              datePublished={datePublished}
              authors={authors}
              analyticsSection="featured"
              {...props}
            />
          </div>
        )}
      </article>
    </section>
  );
};

ChannelPinnedArticle.fragment = gql`
  ${LandingMetadata.fragment}

  fragment channelPinnedArticle on PromoItem {
    id
    url
    title
    dek
    ...landingMetadata
    riverImage(width: 640, height: 400, sizes: ["1x", "2x"]) {
      id
      url
      srcSet
      width
      height
      altText
      attributionText
    }
  }
`;

export default ChannelPinnedArticle;
